import { GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts } from '@/queries/__generated__/paycheckDataForPaycheckListForm';
import { GQL_PaycheckDraftSave } from '@/queries/global';

export default {
  newDraft: (workRelationId: string, periodId: string, active: boolean | null) => (
    {
      __typename: 'PaycheckDraft',
      id: null!,
      workRelation: { __typename: 'WorkRelation', id: workRelationId },
      workRelationId,
      period: { __typename: 'PaycheckPeriod', id: periodId },
      periodId,
      active,
      comment: null,
      paycheck: null,
      paycheckDraftLines: [],
      savedBy: null!,
      savedAt: null,
    } as
      Omit<GQL_paycheckDataForPaycheckListForm_currentUnit_subUnits_workRelations_paycheckDrafts, 'savedAt'> &
      GQL_PaycheckDraftSave &
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      { savedAt: any }
  ),
};
